import { Typography } from '@euler/app/components/typography';
import { useAuthTheme } from '@euler/app/flows/auth/hooks';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FC, memo, useEffect, useState } from 'react';

export const CodeTtl: FC<{ ttl: number; onTimeout: () => void }> = memo(
  ({ ttl, onTimeout }) => {
    const theme = useAuthTheme();
    const { rpx } = useResponsiveContext();
    const [seconds, setSeconds] = useState(ttl);

    useEffect(() => {
      let timer: any = 0;
      let value = ttl;

      const reset = () => {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      };

      const tick = () => {
        reset();

        if (value <= 0) {
          onTimeout();
          return;
        }

        value--;

        setSeconds(value);

        timer = setTimeout(tick, 1000);
      };

      timer = setTimeout(tick, 1000);

      return reset;
    }, [ttl, onTimeout]);

    return (
      <Typography.Label light size={rpx(14)} color={theme.codeTtlTextColor}>
        重新获取验证码{` (${seconds}秒)`}
      </Typography.Label>
    );
  },
);
